import React, { useEffect, useState } from 'react';
import { Confirm, Icon ,Dimmer, Grid, Loader, Segment, Message, Button, Table, Header} from "semantic-ui-react";
import PaymentCard from "../../components/SellerSignup/PaymentCard";
import { getSellerPaymentMethods, swapPaymentMethods, getPaymentIntent ,removePaymentMethods} from '../../services/Seller';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import Config from 'Config'
import SellerStripeForm from '../../components/SellerSignup/SellerStripeForm';
import ErrorBox from '../../components/SellerSignup/ErrorBox';
import './SellerPaymentMethod.less'
import { useSelector } from 'react-redux';
import visaImg from '../../assets/images/newui/sellersignup/card-visa.svg'
import amexImg from '../../assets/images/newui/sellersignup/card-amex.svg'
import masterImg from '../../assets/images/newui/sellersignup/card-master.svg'
import discoverImg from '../../assets/images/newui/sellersignup/card-discover.svg'


const SellerPaymentMethod = () => {
    const [selectedSeller, setSelectedSeller] = useState({});
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});

    const [selectedPaymentMethodForDelete, setSelectedPaymentMethodForDelete] = useState({});
    const [stripe, setStripe] = useState();
    const [card, setCard] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [deleteError, setDeleteError] = useState('');
    
    const [isSuccessMessageShown, setIsSuccessMessageShown] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [deleteConfirmModalOpen,setDeleteConfirmModalOpen] = useState(false);
    const seller = useSelector(({ auth }) => auth.currentUser.Seller);
    const [submitButtonDisabled,setSubmitButtonDisabled] = useState(false);

    useEffect(() => {
        loadStripe(Config.stripe.key).then(res => setStripe(res));
    } ,[])

    useEffect(() => {
        loadData();
    }, [seller])

    const loadData = () => {
        setPaymentMethods([]);
        setSelectedSeller(seller);
        setSelectedPaymentMethod({})
        setSelectedPaymentMethodForDelete({})
        setDeleteConfirmModalOpen(false)
        setDeleteError("");
        setSubmitButtonDisabled(false)
        if (seller.sellerID) {
            getSellerPaymentMethods(seller.sellerID).then(res => {
                if (res.data && res.data.length) {
                    setPaymentMethods(res.data)
                }
                setIsLoading(false)
            })
        }
    }

    const showSuccessMessage = (message) => {
        setIsSuccessMessageShown(true)
        setSuccessMessage(message)
        setTimeout(() => {
            setIsSuccessMessageShown(false);
            setSuccessMessage("")
        }, 4000);
    }

    const onSubmit = async () => {
        try {
            setIsLoading(true)
            setError('')
            setSubmitButtonDisabled(true)

            if (!card) {
                setError('Invalid card details.')
                setSubmitButtonDisabled(false)
                return;
            }

            // payment method creation
            const paymentMethodRes = await stripe.createPaymentMethod({
                type: 'card',
                card
            });
            
            if (paymentMethodRes.error) {
                setError(paymentMethodRes.error.message)
                setSubmitButtonDisabled(false)
                return;
            }
            
            const paymentRes = await getPaymentIntent(selectedSeller.sellerID, 0.5)
            const paymentConfirmation = await stripe.confirmCardPayment(paymentRes.data.client_secret, {
                payment_method: paymentMethodRes.paymentMethod.id,
                setup_future_usage: 'off_session'
            });

            if (paymentConfirmation.error) {
                setError(paymentConfirmation.error.message);
                setSubmitButtonDisabled(false)
            } else {

                const res = await swapPaymentMethods({
                    ssPaymentMethodID: selectedPaymentMethod.ssPaymentMethodID,
                    paymentIntentID: paymentRes.data.id,
                    sellerID: selectedSeller.sellerID
                })

                if (res.resStatus == 200) {
                    showSuccessMessage("Payment method replaced successfully!");
                    loadData();
                } else {
                    setError(res.message)
                    setSubmitButtonDisabled(false)
                }
            }
        } catch (err) {
            console.log(err);
            setSubmitButtonDisabled(false)
        } finally {
            setIsLoading(false)
        }
    }

    const getCardImage = (type) => {
        switch (type) {
            case 'visa':
                return visaImg;
            case 'mastercard':
                return masterImg;
            case 'amex':
                return amexImg;
            case 'discover':
                return discoverImg;
            default:
                return;
        }
    }
    const removePaymentMethod = async () => {
        try{
            setIsLoading(true)
            setDeleteError('')
            
            if(selectedPaymentMethodForDelete.ssPaymentMethodID)
            {  
                
                let res  = await removePaymentMethods(selectedPaymentMethodForDelete.ssPaymentMethodID);
                
                if (res.resStatus == 200) {
                    
                    showSuccessMessage("Selected payment method removed.");
                    loadData();
                } else {
                    setDeleteError(`Card ending with ${selectedPaymentMethodForDelete.id ? selectedPaymentMethodForDelete.card.last4 : "****"} cannot be removed because it is assigned to active subscriptions`)
                }
            }
        }catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false)
        }
    }
    return <>
        {isLoading ? 
        <Dimmer active>
            <Loader indeterminate size='massive' />
        </Dimmer> 
        : ''}

         <Segment.Group>
                <Segment size="massive" className="no-radius">
                    <Header as="h1">
                        <Header.Content>
                            <Icon name='payment' size='small' />
                            Payment Methods
                        </Header.Content>
                    </Header>
                </Segment>
            </Segment.Group>
        <Segment>
           
        
        <div className={"seller-payment-method-container"}>
            {isSuccessMessageShown ?
                <Grid.Row>
                    <Grid.Column width={16}><Message positive>
                        <p>{successMessage}</p>
                    </Message>  </Grid.Column>
                </Grid.Row> : ''}
            {selectedSeller.sellerID && <>
                <Table>
                    {
                        window.innerWidth >= 768 ? 
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Card Number</Table.HeaderCell>
                                    <Table.HeaderCell>Expiry</Table.HeaderCell>
                                    <Table.HeaderCell>Brand</Table.HeaderCell>
                                    <Table.HeaderCell>Actions</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header> : ""
                    }
                    
                    <Table.Body>
                        {
                            paymentMethods.length ? "" :
                                <Table.Row>
                                    <Table.Cell>No Payment Method Found</Table.Cell>
                                </Table.Row>
                        }
                        {
                            paymentMethods.length  > 0 ? <>
                                {
                                    paymentMethods.map(pm => 
                                        <Table.Row className={`${selectedPaymentMethod.id == pm.id ? "seller-payment-method-row-selected" : ""} ${selectedPaymentMethodForDelete.id == pm.id ? "seller-payment-method-row-selected-for-delete" : ""}`}>
                                            <Table.Cell><span>**** **** ****</span> <span>{pm.card.last4}</span></Table.Cell>
                                            <Table.Cell><span>Exp: </span><span>{pm.card.exp_month}/{pm.card.exp_year}</span></Table.Cell>
                                            <Table.Cell><img src={getCardImage(pm.card.brand)} /></Table.Cell>  
                                            <Table.Cell>
                                                    <div>
                                                        <Button disabled={selectedPaymentMethod.id == pm.id ? true : false}
                                                             onClick={() => setSelectedPaymentMethod(pm)} 
                                                            size={"large"} color={"green"}>Replace</Button>
                                                        <Button onClick={() => {
                                                                setSelectedPaymentMethodForDelete(pm); 
                                                                setDeleteConfirmModalOpen(true)
                                                                setDeleteError("");
                                                            }
                                                        } 
                                                        size={"large"} color={"red"}>Remove</Button>
                                                    </div>
                                            </Table.Cell>  
                                        </Table.Row>
                                    )
                                }
                            </> : ""
                        }
                    </Table.Body>
                </Table>

                {/* {paymentMethods.map(pm =>
                    <div className='seller-payment-method-container' onClick={() => setSelectedPaymentMethod(pm)}>
                        <PaymentCard {...pm.card} isSelected={selectedPaymentMethod.id == pm.id} />
                    </div>
                )} */}
                {selectedPaymentMethod.id && 
                    <div className={"seller-payment-method-stripe-form-container"}>    
                        <Elements  stripe={stripe}>
                            <div className='seller-payment-method-header-container'>
                                <div className='seller-payment-method-header' >Replace <span>**** **** ****</span> <span>{selectedPaymentMethod.card.last4} </span> With</div>
                            </div>
                            
                            <ElementsConsumer>
                                {({ stripe, elements }) => (
                                    <SellerStripeForm buttonText="Submit" onChange={({ card }) => setCard(card)} stripe={stripe} elements={elements} />
                                )}
                            </ElementsConsumer>
                        </Elements>

                        {error ? <div className='seller-payment-method-error-container'><ErrorBox message={error} /> </div> : ''}
                        <Button disabled={submitButtonDisabled} size={"big"} className='seller-payment-method-submit' onClick={() => onSubmit()}>Submit</Button>
                    </div>
                }
            </>}     
        </div>
        
        <Confirm className='confirmation-dialog'
                header='Remove Payment Method'
                open={deleteConfirmModalOpen}
                cancelButton="No"
                confirmButton="Yes"
                content={
                    <div className={"seller-payment-method-delete-confirm-content-container"}>
                         <div className={"seller-payment-method-delete-confirm-content-text"}>
                            Are you sure you want to remove Card ending with {selectedPaymentMethodForDelete.id ? selectedPaymentMethodForDelete.card.last4 : "****"} permanently? 
                        </div>
                        {deleteError ? <div className='seller-payment-method-error-delete-container'><ErrorBox message={deleteError} /> </div> : ''}
                    </div>
               
                }
                onCancel={() => {
                        setSelectedPaymentMethodForDelete({})
                        setDeleteConfirmModalOpen(false)
                        setDeleteError("");
                    }
                }
                onConfirm={() => {removePaymentMethod()}}
        >
        </Confirm>
        </Segment></>
}

export default SellerPaymentMethod;